import { FC } from 'react';
import { BiChevronLeftCircle, BiChevronRightCircle } from 'react-icons/bi';
import {
  Button,
  ButtonProps,
  HStack,
  Stack,
  StackProps,
} from '@chakra-ui/react';

type FooterNavigationButtonsProps = StackProps & {
  leftButtonProps?: ButtonProps;
  leftSecondaryButtonProps?: ButtonProps;
  rightButtonProps?: ButtonProps;
  rightSecondaryButtonProps?: ButtonProps;
};

export const FooterNavigationButtons: FC<FooterNavigationButtonsProps> = ({
  leftButtonProps,
  leftSecondaryButtonProps,
  rightButtonProps,
  rightSecondaryButtonProps,
  ...stackProps
}) => (
  <Stack
    direction="row"
    gap={2.5}
    justifyContent="space-between"
    mt="auto"
    pt={28}
    w="full"
    {...stackProps}
  >
    <HStack gap={2}>
      {leftButtonProps && (
        <Button
          colorPalette="navy"
          type="button"
          variant="outline"
          {...leftButtonProps}
        >
          <BiChevronLeftCircle />
          {leftButtonProps.children}
        </Button>
      )}
      {leftSecondaryButtonProps && (
        <Button
          colorPalette="navy"
          type="button"
          variant="outline"
          {...leftSecondaryButtonProps}
        />
      )}
    </HStack>

    <HStack gap={2}>
      {rightSecondaryButtonProps && (
        <Button
          colorPalette="navy"
          type="button"
          variant="outline"
          {...rightSecondaryButtonProps}
        />
      )}
      {rightButtonProps && (
        <Button type="button" {...rightButtonProps}>
          {rightButtonProps.children}
          <BiChevronRightCircle />
        </Button>
      )}
    </HStack>
  </Stack>
);
